import React from 'react'

import Loading from 'shared/Loading'
import Dashboard from 'shared/Dashboard'
import useStyle from 'shared/hooks/useStyle'

import DashboardCardCountedItem from './DashboardCardCountedItem'
import useProcessesWidgetMap from './hooks'
import styles from './ProcessesDashboard.style'

const ProcessesDashboard = () => {
    const classes = useStyle(styles)
    const {
        error,
        isLoading,
        widgetMap,
    } = useProcessesWidgetMap()

    if (error) {
        throw error
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }
    if (widgetMap && widgetMap.length === 0) {
        return (
            <span>No available processes</span>
        )
    }

    return (
        <div css={classes.root}>
            <div css={classes.main}>
                <Dashboard
                    widgets={widgetMap}
                    widgetComponent={DashboardCardCountedItem}
                />
            </div>
        </div>
    )
}

export default ProcessesDashboard
